var map = {
	"./arrow-left-active.svg": "0fd5",
	"./arrow-left.svg": "8cc8",
	"./campaign-active.svg": "fe4f",
	"./campaign.svg": "160d",
	"./catalog-active.svg": "84b3",
	"./catalog.svg": "6a82",
	"./clients-active.svg": "cb28",
	"./clients.svg": "e031",
	"./compilations-active.svg": "9dde",
	"./compilations.svg": "0562",
	"./favorites-active.svg": "6a40",
	"./favorites.svg": "3d81",
	"./help-active.svg": "c7bc",
	"./help.svg": "634a",
	"./import-active.svg": "83a0",
	"./import.svg": "d3a9",
	"./menu-active.svg": "5b9f",
	"./menu.svg": "14f6",
	"./mygroups-active.svg": "674b",
	"./mygroups.svg": "0d06",
	"./post-search-active.svg": "c9e1",
	"./post-search.svg": "959e",
	"./rate-active.svg": "7256",
	"./rate.svg": "f03c",
	"./request-active.svg": "d2ca",
	"./request.svg": "69b3",
	"./settings-active.svg": "f083",
	"./settings.svg": "000e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff4e";